import { useCallback, useSyncExternalStore } from 'react'

const mobilBrekkpunkt = '(max-width: 768px)'

/** Tabellene krever ~960px + sidemarg. Under det viser vi kortliste i stedet for sidescroll. */
const kortlisteBrekkpunkt = '(max-width: 1023px)'

/** Rendrer som desktop på server og ved første render, og bytter etter hydrering. */
function useMediaQuery(query: string) {
    const subscribe = useCallback(
        (onChange: () => void) => {
            const mql = window.matchMedia(query)
            mql.addEventListener('change', onChange)
            return () => mql.removeEventListener('change', onChange)
        },
        [query],
    )

    return useSyncExternalStore(
        subscribe,
        () => window.matchMedia(query).matches,
        () => false,
    )
}

export function useErMobil() {
    return useMediaQuery(mobilBrekkpunkt)
}

export function useErKortliste() {
    return useMediaQuery(kortlisteBrekkpunkt)
}
